import { storageAmenities, vehicleRequirements } from 'config/units';

/**
 * Counts all applied search filters from query params.
 * Used by NewSearchPage, SearchFiltersTray, and toolbar badges.
 *
 * @param {Object} queryParams - Current search query parameters
 * @returns {number} Total count of applied filters
 */
export function countAppliedFilters(queryParams = {}) {
	let count = 0;

	// Price filters (count as 1 if either min or max is set)
	if (
		Number(queryParams.minPrice) > 0 ||
		(queryParams.maxPrice && Number(queryParams.maxPrice) < 500)
	) {
		count += 1;
	}

	// Deals toggle
	if (queryParams.hasSpecial) {
		count += 1;
	}

	// Ratings (only count if not 'all' and is truthy)
	if (queryParams.averageReview && queryParams.averageReview !== 'all') {
		count += 1;
	}

	// Storage size (sqft or onlyLocker - mutually exclusive, count as 1)
	if (queryParams.sqft || queryParams.onlyLocker) {
		count += 1;
	}

	// Vehicle size (minLength - counts as 1)
	if (queryParams.minLength) {
		count += 1;
	}

	// Vehicle accommodation (counts as 1)
	if (queryParams.vehicleAccommodation) {
		count += 1;
	}

	// Storage amenities (each boolean amenity counts as 1)
	// Derive keys from the storageAmenities config to stay in sync
	storageAmenities.forEach((amenity) => {
		if (queryParams[amenity.value]) {
			count += 1;
		}
	});

	// Vehicle requirements (each boolean counts as 1)
	// Derive keys from vehicleRequirements config to stay in sync
	vehicleRequirements.forEach((req) => {
		if (queryParams[req.value]) {
			count += 1;
		}
	});

	return count;
}

export default countAppliedFilters;
